import React from 'react';

export const MobileNavigationEvents = (props) => {
  const { currentSlide, totalSlides, onPrev, onNext } = props;

  const handlePrev = (e) => {
    onPrev();
    // Remove focus to avoid aria-hidden warnings if its ancestor is hidden
    e.currentTarget.blur();
  };

  const handleNext = (e) => {
    onNext();
    e.currentTarget.blur();
  };

  return (
    <div className="d-flex d-xl-none splide__arrows event-arrows position-relative">
      <button
        className="btn splide__arrow splide__arrow--prev"
        onClick={handlePrev}
      >
        <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
          <g clipPath="url(#clip0_2311_1134)">
            <path
              d="M25 12L1 12"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
            <path
              d="M8 19L1 12L8 5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            ></path>
          </g>
          <defs>
            <clipPath id="clip0_2311_1134">
              <rect
                width="26"
                height="24"
                fill="white"
                transform="translate(26 24) rotate(-180)"
              ></rect>
            </clipPath>
          </defs>
        </svg>
      </button>
      <div className="d-inline-flex align-items-center">
        <span className="splide__current">{currentSlide}</span>
        <span className="splide__total">{totalSlides}</span>
      </div>
      <button
        className="btn splide__arrow splide__arrow--next"
        onClick={handleNext}
      >
        <svg width="26" height="24" viewBox="0 0 26 24" fill="none"><g clip-path="url(#clip0_2311_1139)"><path d="M1 12L25 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path><path d="M18 19L25 12L18 5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></g><defs><clipPath id="clip0_2311_1139"><rect width="26" height="24" fill="white" transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 24)"></rect></clipPath></defs></svg>
      </button>
    </div>
  );
};
